import React from 'react';
import { ArrowUpRightIcon, MapPinIcon } from 'lucide-react';
import { buildSteps, corePageTypes, threeDayLaunchUrl } from '../../data/websites';
export function ThreeDayBuild() {
  return <section aria-labelledby="built-in-3-days" className="bg-white px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-876" data-mp="19px7xcfsi4cy">
      <div className="grid gap-12 lg:grid-cols-12 xl:gap-20" data-id="element-877" data-mp="1enyu468iijsn">
        <div className="lg:col-span-7" data-id="element-878" data-mp="1eql2g83893bx">
          <p className="text-[clamp(6rem,12vw,14rem)] font-extrabold leading-[0.85] tracking-tight text-brand-red" aria-hidden="true" data-id="element-879" data-mp="zzlsasmqu6q8">
            3 days
          </p>
          <h2 id="built-in-3-days" className="mt-6 text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-880" data-mp="r07645dm0ibj">
            Why 3 days is possible.
          </h2>
          <p className="mt-5 max-w-[60ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-881" data-mp="h1rp4v8aqpfr">
            We build the core of your website in 3 days. Most websites are built from 5 to 10 main page types. We build
            that core first. After that, new pages take hours, not weeks.
          </p>
          <ul className="mt-6 flex flex-wrap gap-2" aria-label="Core page types" data-id="element-882" data-mp="1hnaut3j8obrt">
            {corePageTypes.map(page => <li key={page} className="rounded-full bg-brand-light px-4 py-2 text-sm font-semibold text-brand-black" data-id="element-883" data-mp="1ql4rwgotv9g1">
                {page}
              </li>)}
          </ul>
        </div>

        <aside aria-labelledby="real-people" className="self-end border-t-4 border-brand-red bg-gray-50 p-8 lg:col-span-5 xl:p-10" data-id="element-884" data-mp="yv08ak8w6qfv">
          <MapPinIcon className="h-7 w-7 text-brand-red" aria-hidden="true" data-id="element-885" data-mp="1cng533b79s8c" />
          <h2 id="real-people" className="mt-4 text-[clamp(1.5rem,2vw,2.25rem)] font-extrabold leading-tight text-brand-black" data-id="element-886" data-mp="17u3u3vzg1jy2">
            Real people in Las Vegas.
          </h2>
          <p className="mt-3 text-lg font-semibold text-brand-black" data-id="element-887" data-mp="f70xj9ebvjag">Real people. Real hours. Right here in the U.S.</p>
          <p className="mt-3 leading-relaxed text-gray-600" data-id="element-888" data-mp="2f7pfbe2f8eyp">
            When you talk to our team, you talk to people in Las Vegas during normal business hours.
          </p>
        </aside>
      </div>

      <ol className="mt-16 grid gap-px overflow-hidden rounded-xl border border-gray-200 bg-gray-200 md:grid-cols-3" data-id="element-889" data-mp="2ozle6rcc093z">
        {buildSteps.map((step, i) => <li key={step.title} className="bg-white p-8 xl:p-10" data-id="element-890" data-mp="1w9uzoh6sf57c" data-mpi={i}>
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-red text-lg font-extrabold text-white" data-id="element-891" data-mp="1wbph3liuof6o">
              {i + 1}
            </span>
            <h3 className="mt-5 text-[clamp(1.25rem,1.5vw,1.75rem)] font-bold text-brand-black" data-id="element-892" data-mp="2679cm6ti5buw">{step.title}</h3>
            <p className="mt-2 text-[clamp(1rem,1.05vw,1.1875rem)] leading-relaxed text-gray-600" data-id="element-893" data-mp="2ab7ayfb06imw">{step.body}</p>
          </li>)}
      </ol>

      <a href={threeDayLaunchUrl} target="_blank" rel="noopener noreferrer" className="group mt-8 inline-flex items-center gap-1.5 text-base font-bold text-brand-red transition-colors duration-150 ease-out hover:text-brand-red-dark focus:outline-none focus-visible:underline" data-id="element-894" data-mp="3loja4cvtid2q">
        See the 3-Day Website Launch
        <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-895" data-mp="117kskastuo3q" />
      </a>
    </section>;
}